import { render, staticRenderFns } from "./RequestsDashboard.vue?vue&type=template&id=91a640d6&"
import script from "./RequestsDashboard.vue?vue&type=script&lang=js&"
export * from "./RequestsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RequestsDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VChip,VCol,VContainer,VProgressLinear,VRow,VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91a640d6')) {
      api.createRecord('91a640d6', component.options)
    } else {
      api.reload('91a640d6', component.options)
    }
    module.hot.accept("./RequestsDashboard.vue?vue&type=template&id=91a640d6&", function () {
      api.rerender('91a640d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduling/reports/RequestsDashboard.vue"
export default component.exports